import { __extends } from 'tslib';
import { ScriptLoader } from 'uitk-react-utils';
import { ThirdPartyAdapter } from './thirdparty-adapter.esm.js';

var GOOGLEMAPS_CATEGORY = 'GOOGLEMAPS';
var PlacesServiceStatus;
(function (PlacesServiceStatus) {
    PlacesServiceStatus["INVALID_REQUEST"] = "INVALID_REQUEST";
    PlacesServiceStatus["OK"] = "OK";
    PlacesServiceStatus["OVER_QUERY_LIMIT"] = "OVER_QUERY_LIMIT";
    PlacesServiceStatus["REQUEST_DENIED"] = "REQUEST_DENIED";
    PlacesServiceStatus["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    PlacesServiceStatus["ZERO_RESULTS"] = "ZERO_RESULTS";
})(PlacesServiceStatus || (PlacesServiceStatus = {}));
var GoogleAdapter = /** @class */ (function (_super) {
    __extends(GoogleAdapter, _super);
    function GoogleAdapter(locale, apiKey) {
        var _this = _super.call(this, locale) || this;
        _this.url = "//maps.googleapis.com/maps/api/js?client=gme-expedia&channel=ess&libraries=places&language=".concat(locale, "&key=").concat(apiKey);
        _this.category = GOOGLEMAPS_CATEGORY;
        _this.sourceName = 'GPA';
        _this.type = 'ADDRESS';
        ScriptLoader.getScript(_this.url)
            .then(function () {
            _this.google = window.google;
            _this.initGooglePlacesService();
        })
            .catch(function (err) {
            console.error(err);
        });
        return _this;
    }
    GoogleAdapter.getInstance = function (locale, apiKey) {
        var thisLocale = locale || 'en_US';
        var thisGoogleApiKey = apiKey || 'AIzaSyABOFQNLMiTVN0AG3eWNmspVfVC8gNda68';
        if (!(thisLocale in this.instances)) {
            this.instances[thisLocale] = new GoogleAdapter(thisLocale, thisGoogleApiKey);
        }
        return this.instances[thisLocale];
    };
    GoogleAdapter.prototype.initGooglePlacesService = function () {
        if (this.google && this.google.maps && this.google.maps.places) {
            var _a = this.google.maps.places, AutocompleteService = _a.AutocompleteService, PlacesService = _a.PlacesService;
            this.googleAutoCompleteService = new AutocompleteService();
            this.placesService = new PlacesService(document.createElement('div'));
        }
    };
    GoogleAdapter.prototype.fetchResults = function (essResponse) {
        var _this = this;
        var request = {
            input: essResponse.q,
            type: essResponse.rc === 'ADDRESS_AUTOCOMPLETE' ? ['geocode'] : undefined
        };
        var toEssResponse = function (results) { return ({
            q: essResponse.q,
            rc: essResponse.rc,
            rid: essResponse.rid,
            sr: results
        }); };
        return new Promise(function (resolve) {
            if (_this.googleAutoCompleteService) {
                _this.googleAutoCompleteService.getPlacePredictions(request, function (predictions, status) {
                    if (status === PlacesServiceStatus.OK) {
                        var response = toEssResponse(_this.handleResponse(predictions));
                        resolve(response);
                    }
                    else {
                        resolve(essResponse);
                    }
                });
            }
            else {
                resolve(essResponse);
            }
        });
    };
    GoogleAdapter.prototype.fetchLocation = function (placeId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var request = {
                    placeId: placeId,
                    fields: ['geometry']
                };
                _this.placesService.getDetails(request, function (place, status) {
                    var _a;
                    if (status === PlacesServiceStatus.OK) {
                        var loc = (_a = place === null || place === void 0 ? void 0 : place.geometry) === null || _a === void 0 ? void 0 : _a.location;
                        if (loc)
                            resolve({
                                lat: loc.lat().toFixed(5),
                                lng: loc.lng().toFixed(5)
                            });
                        else
                            resolve(undefined);
                    }
                    else if (status === PlacesServiceStatus.ZERO_RESULTS)
                        resolve(undefined);
                    else
                        reject(new Error("Failed to fetch location for placeId ".concat(placeId, ": ").concat(status)));
                });
            }
            catch (error) {
                reject(new Error("Failed to fetch location for placeId ".concat(placeId, ": ").concat(error.message)));
            }
        });
    };
    GoogleAdapter.prototype.handleResponse = function (predictions) {
        var _this = this;
        var results = [];
        predictions.forEach(function (prediction, index) {
            results.push(_this.toEssResult(prediction.description, prediction.place_id, index));
        });
        return results;
    };
    GoogleAdapter.instances = {};
    return GoogleAdapter;
}(ThirdPartyAdapter));

export { GOOGLEMAPS_CATEGORY, GoogleAdapter, PlacesServiceStatus };
